import {gsap} from "gsap";

import {ScrollTrigger} from "gsap/ScrollTrigger";



export const ViewTypo = {
    namespace: 'tipologia',
    beforeEnter(data) {

    },
    afterLeave() {



    },
    afterEnter() {


        document.querySelector('.header').classList.add('inverted');

        if (document.querySelectorAll('.accordion').length>0) {

            document.querySelectorAll('.accordion').forEach(el=>{

                let groups = gsap.utils.toArray(".accordion-group",el);
                let menus = gsap.utils.toArray(".accordion-menu",el);
                let isAniMenu = false;

                menus.forEach(menu => {
                    menu.addEventListener("click", () => toggleMenu(menu));
                });

                if (typeof (el.dataset.firstopen) != 'undefined') {
                    toggleMenu(menus[0]);
                }

                function toggleMenu(clickedMenu) {
                    if (clickedMenu.parentNode.classList.contains('active')) {

                        if (isAniMenu == false) {
                            isAniMenu = true

                            let t = clickedMenu.parentNode.querySelector('.accordion-content');
                            gsap.to(t,{
                                height: '0px',
                                onComplete: () => {
                                    isAniMenu = false
                                    clickedMenu.parentNode.classList.remove('active');
                                }
                            })
                        }


                    } else {
                        if (isAniMenu == false) {
                            isAniMenu = true
                            groups.forEach(group => {
                                group.classList.remove('active');
                            });
                            clickedMenu.parentNode.classList.add('active');
                            let t = clickedMenu.parentNode.querySelector('.accordion-content');
                            var tl = gsap.timeline({
                                onComplete: () => {
                                    isAniMenu = false
                                }
                            });

                            tl
                                .add('start')
                                .to('.accordion-content',{
                                    height: '0px',
                                },'start')
                                .to(t,{
                                    overwrite: true,
                                    height: 'auto',
                                },'start')
                        }

                    }
                }



            });

        }

        document.querySelector('.block-products__lm').addEventListener('click',()=>{

            gsap.to('.block-products__lm',{
                opacity: 0,
                onComplete: ()=> {
                    gsap.set('.block-products__lm',{
                        display: 'none'
                    })
                }
            });

            gsap.to('.not-active',{
                opacity: 1,
                onStart: () => {
                    gsap.set('.not-active',{
                        display: 'block'
                    })
                },
                onComplete: () => {
                    document.querySelectorAll('.not-active').forEach(el=>{
                        el.classList.remove('not-active')
                    })
                }
            })
        })

        let $filters = document.querySelectorAll('.block-products__filters a');

        $filters.forEach(el=>{

            el.addEventListener('click',()=>{

                $filters.forEach(item=>{
                    item.classList.remove('active');
                })

                el.classList.add('active')

                let target = el.dataset.filter;

                if (target == '') {
                    target = '.block-products__list-item';
                }



                gsap.set('.block-products__list',{
                    height: () => {

                        return document.querySelector('.block-products__list').clientHeight

                    }
                })



                gsap.to('.block-products__list-item.active',{
                    stagger: 0.2,
                    opacity: 0,
                    onComplete: () => {
                        gsap.set('.block-products__list-item',{
                          display: 'none'
                        })

                        gsap.to(target,{
                            stagger: 0.2,
                            opacity: 1,
                            delay:.1,
                            onStart: () => {
                                gsap.set('.block-products__list',{
                                    clearProps: 'all'
                                })
                                gsap.set(target,{
                                    display: 'block',
                                    opacity: 0
                                })
                            },
                            onComplete: () => {

                                document.querySelectorAll('.block-products__list-item').forEach(el=>{
                                    el.classList.remove('active');
                                })

                                document.querySelectorAll(target).forEach(el=>{
                                    el.classList.add('active');
                                })
                            }
                        })


                    }
                })

            })
        })

    }
}
